import React, {Component} from 'react';
import SocialMedia from "./Groups/SocialMedia.js";
import Wiki from "./Groups/Wiki.js";
import Trademarks from "./Groups/Trademarks.js";
import Trends from "./Groups/Trends.js";
import Stores from "./Groups/Stores.js";
import Summary from "./Groups/Summary.js";
import NeuralNetwork from "./Groups/NeuralNetwork.js";
import DomainsGroup from "./Groups/DomainsGroup.js";
import './App.css';

class Results extends Component {
  add(source, content, searchQuery) {
    for (var ref in this.refs) {
      if (ref.substr(0, 5) === "group") {
        // this.refs[ref].clear();
        this.refs[ref].addResult(source, content, searchQuery);
        //this.refs[ref].setState({noSearches: false});
      }
    }
  }

  clear() {
    for (var ref in this.refs) {
      if (ref.substr(0, 5) === "group") {
        this.refs[ref].clear();
      }
    }
  }

  render() {
    return (
      <div className="resultArea">
        <div className="Summary resultArea__card">
          <Summary ref="groupSummary"/>
        </div>
        <div className="SocialMediaDiv resultArea__card">
          <SocialMedia ref="group1"/>
        </div>
        {/* <div className="GroupBox resultArea__card">
          <NeuralNetwork ref="group2"/>
        </div> */}
        <div className="GroupBox resultArea__card">
          <DomainsGroup ref="group3"/>
        </div>
        <div className="GroupBox resultArea__card" id="trademarks-box">
          <Trademarks ref="group4" query={this.props.query}/>
        </div>
        <div className="GroupBox resultArea__card">
          <Stores ref="group5"/>
        </div>
        <div className="GroupBox resultArea__card">
          <Trends ref="group6"/>
        </div>
        <div className="GroupBox resultArea__card">
          <Wiki ref="group7"/>
        </div>
      </div>
    );
  }
}

export default Results;



// WEBPACK FOOTER //
// ./client/src/Results.js